// extracted by mini-css-extract-plugin
module.exports = {"container":"Notification_container__t8rul","card_container":"Notification_card_container__3GqsA","confirm":"Notification_confirm__3q1gS","text":"Notification_text__3_LIt"};